import React, { Component } from 'react';
import { Link, Redirect } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import Add_ticket from './../../assets/images/add.png';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {Multiselect} from 'multiselect-react-dropdown';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
//import Login from "./App";
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
class TicketList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            tickets: [],
            owners: [],
            internalowners: [],
            status: 'Open',
            priority: 'all',
            prioritySelect:[],
            allcustomer: 'all',
            type: 'all',
            ticketType: [],
            customer: '',
            searchkeyword: '',
            level: 'all',
            levelSelect:[],
            owner: 'all',
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            activePage: 1,
            item_count: '',
            message: '',
            savedFilter: 'all',
            saved_filters: [],
            checkBox: true,
            setdefault: '',
            loading: 1,
            isLoadMore: '',
            errorText: '',
            search: [],
            searchloadmore: '',
            searchText: '',
            last_update:'all',
            sort: 'DESC',
            titlem: '',
            oo: null,
            customerIds: [],
            myAll: [],
            ownersId: [],
            limit: null,
            height: null,
            heightOwner: null,
            ticketOwner: '',
            customersType: [],
            ticketStatusId: [],
            statusclass: false,
            priorityclass: false,
            customerclass: false,
            ownerclass: false,
            customertypeclass: false,
            levelclass: false,
            typeclass: false,
            allTicketOwner: false
        };
        this.statusChange = this.statusChange.bind(this);
        this.priortyChange = this.priortyChange.bind(this);
        this.customerChange = this.customerChange.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
        this.levelChange = this.levelChange.bind(this);
        this.ownerChange = this.ownerChange.bind(this);
        this.savedFilterChange = this.savedFilterChange.bind(this);
        this.lastUpdateChange = this.lastUpdateChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.tick = this.tick.bind(this);
        this.getShortTitle = this.getShortTitle.bind(this);
        this.enterKeyPress = this.enterKeyPress.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.multiselectCustomerName = React.createRef();
        this.multiRef = React.createRef();
        this.customertypeRef = React.createRef();
        this.allOwnerRef = React.createRef();
        this.statusRef = React.createRef();
        this.ticketTypeRef = React.createRef();
        this.priorityRef = React.createRef();
        this.levelsRef = React.createRef();
        document.title = "Intranet | Tickets";
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
         rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    getTicketTitle(searchText = '') {
        fetch(this.state.apiUrl + '/TicketRest/getTicketsTitle/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.tickets,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }

    handleUpdateInput = (searchText) => {
        // console.log(searchText)
        this.setState({
            searchText: searchText,
        });
        this.getTicketTitle(searchText);
    };
    handleNewRequest = (searchText) => {
        // console.log("hi" + this.state.searchText)
        this.ticketsList();
    };
    enterKeyPress(event) {
        if (event.key == 'Enter') {
            this.ticketsList();
        }
    }
    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }
    tick() {
        this.setState({
            checkBox: !this.state.checkBox
        })

        this.state.checkBox ? this.setState({ setdefault: '1' }) : this.setState({ setdefault: '' })

    }

    statusChange(event) {
        this.setState({
            status: event.target.value,
            activePage: 1,
            loading: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                //console.log(findresponse.tickets.length)
                if (findresponse.tickets.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                }
                else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    tickets: this.state.tickets.concat(findresponse.tickets),
                })

            })

    }
    searchLoadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/TicketRest/getSearchTickets/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                //console.log(findresponse.tickets.length)
                if (findresponse.tickets.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                }
                // else{
                //     this.setState({
                //         isLoadMore:1
                //      })
                // }
                this.setState({
                    tickets: this.state.tickets.concat(findresponse.tickets),
                })

            })
    }
    priortyChange(event) {

        this.setState({
            priority: event.target.value,
            activePage: 1,
            loading: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    typeChange(event) {
        this.setState({
            type: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }

    customerChange(event) {
        this.setState({
            allcustomer: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }

    levelChange(event) {
        this.setState({
            level: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    searchChange(event) {
        this.setState({
            customer: event.target.value,
            activePage: 1,
            tickets: [],
            //loading:1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    keywordChange(event) {
        this.setState({
            searchkeyword: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    savedFilterChange(event) {
        this.setState({
            savedFilter: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    lastUpdateChange(event) {
        this.setState({
            lastUpdate: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    jumpSubmit(event) {
        if (event.key == 'Enter') {
            if (!event.target.value.match(/^[0-9]+$/)) {
                alert('Only Number');
                return false;
            }
            else {
                fetch(this.state.apiUrl + '/TicketRest/Viewticketid/userAuthKey/' + this.state.userAuthKey + "/id/" + event.target.value)
                    .then((Response) => Response.json())
                    .then((responseJson) => {
                        console.log(responseJson)
                        if (responseJson.code == 200) {
                            window.location.href = '/ticket/viewTicket/id/' + responseJson.ticketid;
                        } else {
                            this.setState({ message: responseJson.msg })
                        }

                    })

            }

        }
    }
  back() {
          this.state.ownersId = [];
        this.state.ticketStatusId = [];
        this.setState({customerIds: [], ownersId: [], ticketOwner: '',
        ticketType:[],
        prioritySelect:[],
        levelSelect:[],
        customersType:[],
        typeclass: false,
        levelclass: false,
        customertypeclass: false,
        ownerclass: false,
        customerclass: false,
        priorityclass: false,
        statusclass: false,
        statusclass: false 
    }, () =>{

            this.state.customerIds.length > 3 ? this.setState({height: 'heightClass'}) : this.setState({height: null});
            this.state.ownersId.length > 3 ? this.setState({heightOwner: 'heightClass'}) : this.setState({heightOwner: null});
        });
        
             this.multiselectCustomerName.current.resetSelectedValues();
        this.customertypeRef.current.resetSelectedValues();
        this.levelsRef.current.resetSelectedValues();
        this.priorityRef.current.resetSelectedValues();
        this.ticketTypeRef.current.resetSelectedValues();
        this.statusRef.current.resetSelectedValues();
        this.allOwnerRef.current.resetSelectedValues();
        this.customertypeRef.current.resetSelectedValues();
        localStorage.setItem('searchText', '');
        var obj = this;
        this.setState(
            { searchText: '', 
            status: '', 
            allcustomer: 'all', 
            priority: 'all',
            savedFilter: 'all' 
        }, () => obj.ticketsList()
        );
    }


    ownerChange(event) {
        this.setState({
            owner: event.target.value,
            activePage: 1,
            tickets: [],
            loading: 1
        }, function () {
            //console.log(this.state);
            this.ticketsList();
            this.props.history.push('/tickets');
        });
    }
    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/TicketRest/getTickets/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        tickets: findresponse.tickets,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }
    ticketsList(page = 1) {
        this.setState({ searchText: this.state.searchText });
        localStorage.setItem('searchText', this.state.searchText);
        fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey + '/page/' + page, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                // console.log(findresponse)
                this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets,
                    owners: findresponse.owner,
                    saved_filters: findresponse.saved_filters,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }
    getdateTime(datetime) {
        var d = new Date(datetime);
        d.setHours(d.getHours() + 5);
        var aaa = d.setMinutes(d.getMinutes() + 30);
        //return datetime;
        let time = new Intl.DateTimeFormat('en-US', {
            year: 'numeric', month: 'long', day: '2-digit', hour: 'numeric', minute: 'numeric', timeZoneName: 'short',
            timeZone: 'Asia/Kolkata',
        }).format(new Date(aaa));
        var res = time.replace("GMT+5:30", "IST");
        return res;
    }
    savefilter() {
        fetch(this.state.apiUrl + '/ticketRest/saveFilter/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            //.then((Response) => Response.json())
            .then((findresponse) => {
                console.log(findresponse)
                this.ticketsList();
                this.setState({
                    activePage: 1,
                    tickets: [],
                    loading: 1
                })

            })
    }
    getSlaClass(sla, status) {
        var css = '';
        if (status == 'Closed') {
            css = 'tickets_number gray'
        }
        else if (sla == 1) {
            css = 'tickets_number red'
        } else {
            css = 'tickets_number'
        }
        return css;
    }
    studioName(studioname, ticket_master_id) {
        var studio = '';
        if (ticket_master_id != 0) {
            studio = studioname;
        } else {
            studio = 'All Stores';
        }
        return studio;
    }
    showhelpdeskid(url, id) {
        if (id != '') {
            var win = window.open(url + id, '_blank');
            win.focus()
        }
    }
    getTilteStyle(replied_status, added_via) {
        if (replied_status == 0) {
            return 'ticket_title ticket_read'
        }
        else if (added_via == 'cms' || added_via == 'email') {
            return 'ticket_title ticket_read'
        }
        else {
            return 'ticket_read'
        }
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else if (this.state.searchloadmore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.searchLoadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }
    getShortTitle(str) {
        let title = '';
        if (str != null) {
            var len = str.length;
            title = str;
            if (len > 30) {
                title = str.substring(0, 30) + '....';
            }

        }
        return title;
    }
    getType(type) {
        var issue_type = '';
        if (type != '') {
            issue_type = type;
            if (type == 'SetupMigration') {
                issue_type = 'Setup/Migration';
            }
        }
        return issue_type;
    }
    goToTicketDetails(ticketid, ownerid, ownername) {
        localStorage.setItem('ownerid', ownerid);
        localStorage.setItem('ownername', ownername);
        //window.location.href='/ticket/viewTicket/id/'+ticketid;
        this.props.history.push('/ticket/viewTicket/id/' + ticketid);
    }
    getAllfilterKeys() {
        var filter_keys = ["searchvalue"];
        return filter_keys;
    }


     sorting(param, id)
    {
        //console.log(param);
           this.setState({

            sort: this.state.sort === 'DESC' ? 'ASC' : 'DESC',
            titlem: param
           }, () => {

                     this.setState({ searchText: this.state.searchText });
        localStorage.setItem('searchText', this.state.searchText);
        fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                const classn = document.getElementById(`${id}`).getElementsByTagName('i')[0].className;  
    
                if(classn == 'fa fa-sort-desc' && this.state.sort == 'DESC')
                {
                    document.getElementById(`${id}`).getElementsByTagName('i')[0].className = "fa fa-sort-asc";
                }
                else
                {
                    document.getElementById(`${id}`).getElementsByTagName('i')[0].className = "fa fa-sort-desc";
                }
                findresponse = this.rawjsonparse(findresponse, 1);
                // console.log(findresponse)
                this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets,
                    owners: findresponse.owner,
                    saved_filters: findresponse.saved_filters,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })


           });



           //console.log(this.state.sort);

           
    }


    setLimit = (event) => {

        this.setState({
            limit: event.target.value
        }, () => {

            fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    this.setState({
                        loading: 0,
                        isLoadMore: 1,
                        tickets: findresponse.tickets,
                        owners: findresponse.owner,
                        saved_filters: findresponse.saved_filters,
                        item_count: findresponse.item_count,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        })

    }


    getTicketRows() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            return (
                <div class="list_check">

                    <div class="tickets hidden-sm">
                        <ul class="tickets_head ticket_listing_page">
                            <li class="intra_col_6 text-center" onClick={() => this.sorting('id', 'intraticket') } id="intraticket">#Ticket <i class="fa fa-sort"></i></li>
                            <li class="intra_col_15" onClick={() => this.sorting('studio_name', 'intracustomer')} id="intracustomer">Customer <i class="fa fa-sort"></i></li>
                            <li class="intra_col_20" onClick={() => this.sorting('title', 'intratitle')} id="intratitle">Title <i class="fa fa-sort"></i></li>
                            <li class="intra_col_6" onClick={() => this.sorting('helpdesk_id','ticketer')} id="ticketer">#ER <i class="fa fa-sort"></i></li>
                            <li class="intra_col_6" onClick={() => this.sorting('priority','intrapriority')} id="intrapriority">Priority <i class="fa fa-sort"></i></li>
                            <li class="intra_col_6" onClick={() => this.sorting('status','intrastatus')} id="intrastatus">Status <i class="fa fa-sort"></i></li>
                            <li class="intra_col_10" onClick={() => this.sorting('type', 'intratype')} id="intratype">Type <i class="fa fa-sort"></i></li>
                            <li class="intra_col_10" onClick={() => this.sorting('owner', 'intraowner')} id="intraowner">Owner <i class="fa fa-sort"></i></li>
                            <li class="intra_col_10 text-center" onClick={ () => this.sorting('age','intraage')} id="intraage">Age <span className="short">(Days)</span><i class="fa fa-sort"></i></li>
                            <li class="intra_col_11" onClick={ () => this.sorting('created_date','intralastupdatedate')} id="intralastupdatedate">Last Update<span className="short">(Days)</span> <i class="fa fa-sort"></i></li>
                        </ul>
                        {
                            this.state.tickets.map((ticket, key) =>
                                <ul class={`ticket_class ${this.getSlaClass(ticket.sla, ticket.status)}`} >
                                    {/* <li class="intra_col_6 text-center"> <a href={`/ticket/viewTicket/${ticket.id}`}> {ticket.id}</a></li> */}
                                    <li class="intra_col_6 text-center"><Link key={key} to={`/ticket/viewTicket/id/${ticket.id}`} name={"max"} className="">
                                        {ticket.id}</Link></li>
                                    <li class="intra_col_15">{this.studioName(ticket.studio_name, ticket.ticket_master_id)}</li>
                                    <li class="intra_col_20">
                                    <Link key={key} to={`/ticket/viewTicket/id/${ticket.id}`} name={"max"}> 
                                    <div className={this.getTilteStyle(ticket.replied_status, ticket.added_via)}><div dangerouslySetInnerHTML={{ __html: ticket.title }} /></div>
                                    </Link>{/*<div class="note_ticket text-inded" dangerouslySetInnerHTML={{ __html: ticket.note }} />*/}</li>
                                    <li class="intra_col_6 color-sky">
                                        <ul className="mantis">
                                            {ticket.helpdesk_id ? ticket.helpdesk_id.split(",").map(place =>
                                                <li><a onClick={() => this.showhelpdeskid('/viewEr/', place)}> {place}</a></li>) : ""
                                            }
                                        </ul>
                                    </li>
                                    <li class="intra_col_6"> {ticket.priority}</li>
                                    <li class="intra_col_6"> {ticket.status}</li>
                                    <li class="intra_col_10 text-inded">{this.getType(ticket.type)}</li>
            <li class="intra_col_10 text-inded"><Link to={`/viewEmployee/${ticket.assigned_to}`} name={"max"}>{ticket.owner}</Link></li>
                                    <li class="intra_col_10 text-center">{ticket.age_nw}</li>
                                    <li class="intra_col_11 text-center">{ticket.last_updated_date_nw}</li>
                                </ul>

                            )
                        }
                    </div>
                    <div class="tickets_mob hidden-md">
                        {
                            this.state.tickets.map((ticket, key) =>
                                <div class="list_mob">
                                    <span onClick={() => this.goToTicketDetails(ticket.id, ticket.assigned_to, ticket.owner)}>
                                        <h4 class="list_title"><div className={this.getTilteStyle(ticket.replied_status, ticket.added_via)}>{ticket.title} </div><div class="note_ticket text-inded" dangerouslySetInnerHTML={{ __html: ticket.note }} /></h4>
                                        <div class="section">
                                            <div class="wrap pull-left">
                                                <label>#Ticket:</label><span>{ticket.id}</span>
                                            </div>
                                            <div class="wrap pull-right">
                                                <label>Priority</label><div class="text-capitalize">{ticket.priority}</div>
                                            </div>
                                        </div>
                                        <div class="section gry">
                                            <div class="wrap">
                                                <label>Customer</label><span>{ticket.studio_name}</span>
                                            </div>
                                            <div class="wrap pull-right">
                                                <label>{ticket.owner ? 'Owner:' : ''}</label><span>{ticket.owner}</span>
                                            </div>
                                        </div>
                                    </span>
                                </div>

                            )
                        }
                    </div>
                   {this.state.item_count > 0 ? <div class="pagination-muvi newstyle">
                        <div className="pagination_break">
                            
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div></div>
                        
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={1}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        /> <div><select onChange={ this.setLimit}>
                            <option value="20">20</option><option value="50" selected>50</option><option value="100">100</option></select></div>
                    
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}                    {/* {this.loadMorecount()} */}
                        </div>
            )
        }
    }
    componentDidMount() {
        function getUrlVars() {
            var url_value = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                url_value[key] = value;
            });
            return url_value;
        }
        if (window.location.search != '') {
            localStorage.setItem('ticket_user_id', getUrlVars()["ticket_user_id"]);
        }
        else {
            localStorage.setItem('ticket_user_id', '');
        }

        document.title = "Intranet | Tickets";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        if (localStorage.getItem("ticket_user_id")) {
            this.setState({
                owner: localStorage.getItem("ticket_user_id")
            }, function () {
                this.ticketsList();
            })
        }
        else if (localStorage.getItem("searchText")) {
            this.setState({
                searchText: localStorage.getItem("searchText"),
            }, function () {
                this.ticketsList();
            })
        } else {
            this.ticketsList();
        }
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function () {
                //ticketsList();
                // window.location.reload();
            }, 10000);
            //Responsive filter
            $('.searchTicket.dept').on('click', function () {
                $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
            });
        });
    }

    componentWillMount()
    {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get('ticket_user_id');

        this.setState({
            allTicketOwner: foo ? true : false
        })
    
        if(foo){
            
           
            this.state.ownersId = [];
            this.state.ticketStatusId = [];
            this.state.ownersId.push(foo);
            this.state.ticketStatusId.push('Open','Re-opened')
         
        }
        else
        {
            
            this.state.ownersId = [];
            this.state.ticketStatusId = [];
            //this.state.ownersId.push(this.state.userId);
            //this.state.ticketStatusId.push('Open','Re-opened')  
        }


        fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.scrollTo(0, 0);
                findresponse = this.rawjsonparse(findresponse, 1);
                // console.log(findresponse)
                this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets,
                    filterTickets: findresponse.tickets,
                    owners: findresponse.owner,
                    saved_filters: findresponse.saved_filters,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }
  

    autoHandler = (e) => {

            this.setState( {

                oo: e.target.value
            }, () => {

                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                // console.log(findresponse)
                this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets,
                    owners: findresponse.owner,
                    saved_filters: findresponse.saved_filters,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
            })

            
        }

    onSelect = (selectedList, selectedItem) => {
            
         if(this.multiselectCustomerName.current.state.selectedValues.length >= 2){

                this.setState({
                    customerclass: true
                })
        }
         this.state.customerIds.push(selectedItem.id);
        this.state.customerIds.length > 3 ? this.setState({height: 'heightClass'}) : '';
         fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state)
        }).then((Response) => Response.json())
        .then((findresponse) => {
                        findresponse = this.rawjsonparse(findresponse, 1);
                        //console.log(findresponse)
                         this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets,
                    owners: findresponse.owner,
                    saved_filters: findresponse.saved_filters,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            
        })
    }

    onRemove = (selectedList, removedItem) => {
                if(this.multiselectCustomerName.current.state.selectedValues.length < 2){

                this.setState({
                    customerclass: false
                })
                }
            if( removedItem == 0)
            {
                this.setState({ height: null, customerIds: []}, () => this.ticketsList());
            }
          const index = this.state.customerIds.indexOf(removedItem.id);
          
          if(index > -1)
          {
              this.state.customerIds.splice(index, 1)

              if(this.state.customerIds.length > 0)
              {
                
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'
                        })
                    })
              }
              else
              {
                this.ticketsList();
                this.setState({height: null});
                }
           
          }
        }

    componentDidMount = () => {
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
                this.ticketsList();
            fetch(this.state.apiUrl + '/TicketRest/allCustomerName/userAuthKey/' + this.state.userAuthKey, {
                dataType: 'json'
            }).then((Response) => Response.json())
            .then((findresponse) => {
                            findresponse = this.rawjsonparse(findresponse, 1);
                            //console.log(findresponse)
                             this.setState({
                        myAll: findresponse.customer
                    })
                
            })
        }

    ownerSelect(selectedList, selectedItem)
        {
            if(this.allOwnerRef.current.state.selectedValues.length >= 2){

                this.setState({
                    ownerclass: true
                })
                }
            
                this.state.ownersId.push(selectedItem.id);
                this.state.ownersId.length > 2 ? this.setState({heightOwner: 'heightClass'}) : '';
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'

                        })
                    })
        }

    ownerRemove( selectedList, removedItem)
        {
            if(this.allOwnerRef.current.state.selectedValues.length < 2){

                this.setState({
                    ownerclass: false
                })
                }
            const index = this.state.ownersId.indexOf(removedItem.id);
            if( removedItem == 0)
            {
                this.setState({ heightOwner: null, ownersId: []}, () => this.ticketsList());
            }
            if(index > -1)
            {
                this.state.ownersId.splice(index, 1)
  
                if(this.state.ownersId.length >= 0)
                {
                  
                  fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                      method: 'POST',
                      dataType: 'json',
                      body: JSON.stringify(this.state),
                  }).then((Response) => Response.json())
                  .then((findresponse) => {
                                  findresponse = this.rawjsonparse(findresponse, 1);
                                   this.setState({
                              loading: 0,
                              isLoadMore: 1,
                              tickets: findresponse.tickets,
                              owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'

                          })
                      })
                }
                else
                {
                  this.ticketsList();
                  this.setState({heightOwner: null});
                  }
             
            }
            else
            {
                this.ticketsList();

                this.setState({heightOwner: null});
            }
        }

        customerSelect = (selectedList, selectedItem) => {


        if(this.customertypeRef.current.state.selectedValues.length >= 2){

            this.setState({
                customertypeclass: true
            })
            }
        this.state.customersType.push(selectedItem.id);
        this.state.customersType.length > 2 ? this.setState({height: 'heightClass'}) : '';
        fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state)
        }).then((Response) => Response.json())
        .then((findresponse) => {
                        findresponse = this.rawjsonparse(findresponse, 1);
                        //console.log(findresponse)
                         this.setState({
                    loading: 0,
                    isLoadMore: 1,
                    tickets: findresponse.tickets
                })
            
        })

    }


    customerRemove = (selectedList, removedItem) => {

         if(this.customertypeRef.current.state.selectedValues.length < 2){

                this.setState({
                    customertypeclass: false
                })
                }

            if( removedItem == 0)
            {
                this.setState({ height: null, customersType: []}, () => this.ticketsList());
            }
          const index = this.state.customersType.indexOf(removedItem.id);
          
          if(index > -1)
          {
              this.state.customersType.splice(index, 1)

              if(this.state.customersType.length >= 0)
              {
                
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets
                        })
                    })
              }
              else
              {
                this.ticketsList();
                this.setState({height: null});
                }
           
          }

        }


        ticketSelect = (selectedList, selectedItem) => {

            if(this.statusRef.current.state.selectedValues.length >= 2){

                    this.setState({
                        statusclass: true
                    })
            }

            this.state.ticketStatusId.push(selectedItem.status);
                this.state.ticketStatusId.length > 2 ? this.setState({heightOwner: 'heightClass'}) : '';
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            filterTickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'
                        })
                    })
        }

        ticketRemove = (selectedList, removedItem) => {
            if(this.statusRef.current.state.selectedValues.length < 2){

                this.setState({
                    statusclass: false
                })
        }

            const index = this.state.ticketStatusId.indexOf(removedItem.status);
            if( removedItem == 0)
            {
                this.setState({ heightOwner: null, ticketStatusId: []}, () => this.ticketsList());
            }
            if(index > -1)
            {
                this.state.ticketStatusId.splice(index, 1)
  
                if(this.state.ticketStatusId.length >= 0)
                {
                  
                  fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                      method: 'POST',
                      dataType: 'json',
                      body: JSON.stringify(this.state),
                  }).then((Response) => Response.json())
                  .then((findresponse) => {
                                  findresponse = this.rawjsonparse(findresponse, 1);
                                   this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            filterTickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'

                          })
                      })
                }
                else
                {
                  this.ticketsList();
                  this.setState({heightOwner: null});
                  }
             
            }
            else
            {
                this.ticketsList();

                this.setState({heightOwner: null});
            }
        }

        ticketselectoption = (selectedList, selectedItem) => {

            if(this.ticketTypeRef.current.state.selectedValues.length >= 2){

                this.setState({
                    typeclass: true
                })
        }
            this.state.ticketType.push(selectedItem.id);
                this.state.ticketType.length > 2 ? this.setState({heightOwner: 'heightClass'}) : '';
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            filterTickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'
                        })
                    })
        }

        ticketremoveoption = (selectedList, removedItem) => {
             if(this.ticketTypeRef.current.state.selectedValues.length < 2){

                this.setState({
                    typeclass: false
                })
        }

            const index = this.state.ticketType.indexOf(removedItem.id);
            if( removedItem == 0)
            {
                this.setState({ heightOwner: null, ticketStatusId: []}, () => this.ticketsList());
            }
            if(index > -1)
            {
                this.state.ticketType.splice(index, 1)
  
                if(this.state.ticketType.length > 0)
                {
                  
                  fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                      method: 'POST',
                      dataType: 'json',
                      body: JSON.stringify(this.state),
                  }).then((Response) => Response.json())
                  .then((findresponse) => {
                                  findresponse = this.rawjsonparse(findresponse, 1);
                                   this.setState({
                              loading: 0,
                              isLoadMore: 1,
                              tickets: findresponse.tickets
                          })
                      })
                }
                else
                {
                  this.ticketsList();
                  this.setState({heightOwner: null});
                  }
             
            }
            else
            {
                this.ticketsList();

                this.setState({heightOwner: null});
            }

        }

        ticketPrioritySelect = ( selectedList, selectedItem) => {
            if(this.priorityRef.current.state.selectedValues.length >= 2){

                this.setState({
                    priorityclass: true
                })
        }

            this.state.prioritySelect.push(selectedItem.type);
                this.state.prioritySelect.length > 2 ? this.setState({heightOwner: 'heightClass'}) : '';
                fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                }).then((Response) => Response.json())
                .then((findresponse) => {
                                findresponse = this.rawjsonparse(findresponse, 1);
                                 this.setState({
                            loading: 0,
                            isLoadMore: 1,
                            tickets: findresponse.tickets,
                            filterTickets: findresponse.tickets,
                            owners: findresponse.owner,
                            saved_filters: findresponse.saved_filters,
                            item_count: findresponse.item_count,
                            offset: findresponse.offset,
                            off_count: findresponse.off_count,
                            setPage: 'yes'
                        })
                    })

        }

        ticketPriorityRemove = (selectedList, removedItem) => {
            if(this.priorityRef.current.state.selectedValues.length < 2){

                this.setState({
                    priorityclass: false
                })
        }

            const index = this.state.prioritySelect.indexOf(removedItem.type);
            if( removedItem == 0)
            {
                this.setState({ heightOwner: null, prioritySelect: []}, () => this.ticketsList());
            }
            if(index > -1)
            {
                this.state.prioritySelect.splice(index, 1)
  
                if(this.state.prioritySelect.length >= 0)
                {
                  
                  fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                      method: 'POST',
                      dataType: 'json',
                      body: JSON.stringify(this.state),
                  }).then((Response) => Response.json())
                  .then((findresponse) => {
                                  findresponse = this.rawjsonparse(findresponse, 1);
                                   this.setState({
                              loading: 0,
                              isLoadMore: 1,
                              tickets: findresponse.tickets
                          })
                      })
                }
                else
                {
                  this.ticketsList();
                  this.setState({heightOwner: null});
                  }
             
            }
            else
            {
                this.ticketsList();

                this.setState({heightOwner: null});
            }

        }

        ticketLevelSelect = (selectedList, selectedItem) =>{

            if(this.levelsRef.current.state.selectedValues.length >= 2){

                this.setState({
                    levelclass: true
                })
        }
            this.state.levelSelect.push(selectedItem.type);
            this.state.levelSelect.length > 2 ? this.setState({heightOwner: 'heightClass'}) : '';
            fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            }).then((Response) => Response.json())
            .then((findresponse) => {
                            findresponse = this.rawjsonparse(findresponse, 1);
                             this.setState({
                        loading: 0,
                        isLoadMore: 1,
                        tickets: findresponse.tickets,
                        filterTickets: findresponse.tickets,
                        owners: findresponse.owner,
                        saved_filters: findresponse.saved_filters,
                        item_count: findresponse.item_count,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }

        ticketLevelRemove = ( selectedList, removedItem) => {

            if(this.levelsRef.current.state.selectedValues.length < 2){

                this.setState({
                    levelclass: false
                })
            }
            const index = this.state.levelSelect.indexOf(removedItem.type);
            if( removedItem == 0)
            {
                this.setState({ heightOwner: null, levelSelect: []}, () => this.ticketsList());
            }
            if(index > -1)
            {
                this.state.levelSelect.splice(index, 1)
  
                if(this.state.levelSelect.length > 0)
                {
                  
                  fetch(this.state.apiUrl + '/TicketRest/getTickets/userAuthKey/' + this.state.userAuthKey, {
                      method: 'POST',
                      dataType: 'json',
                      body: JSON.stringify(this.state),
                  }).then((Response) => Response.json())
                  .then((findresponse) => {
                                  findresponse = this.rawjsonparse(findresponse, 1);
                                   this.setState({
                              loading: 0,
                              isLoadMore: 1,
                              tickets: findresponse.tickets
                          })
                      })
                }
                else
                {
                  this.ticketsList();
                  this.setState({heightOwner: null});
                  }
             
            }
            else
            {
                this.ticketsList();

                this.setState({heightOwner: null});
            }

        }
        

    render(){
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        
        return (
            <div>
                <Header brecum_name="Support" brecum_page="Ticket List" />
                <div class="right_col">
                    {/* <h1>count {this.state.item_count}</h1> */}
                    {/* <--modal start-!> */}
                    <div class="modal fade" id="myModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Save As Filter</h4>
                                </div>
                                <div class="modal-body">
                                    Name
                        <input type="text" class="form-control" name="filter_name" id="filter_name" onChange={this.onChange} />
                                </div>
                                <div class="radio feature-check">
                                    <input class="valid_fld" id="2" type="checkbox" onClick={this.tick}
                                        defaultChecked={this.state.check} />
                                    <label for="2">
                                        <span></span>
                                        Set As Default
                            </label>
                                </div>

                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-sky" data-dismiss="modal" onClick={() => this.savefilter()}>Submit</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--modal start-!> */}
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span>Ticket List</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="top-row">
                            <div class="left-section btn-muvi pull-left">
                                <Link to="/addticket" class="btn btn-sky mob">
                                    <span class="hidden-sm">Add Ticket</span>
                                    <span class="mob_icon_plus hidden-md">
                                        <i class="fal fa-plus"></i>
                                    </span>
                                </Link>
                            </div>
                            <div class="right-section">
                                <div class="row er_box">
                                    <div class="col-md-8 col-xs-12 pull-right">
                                        <div class="react_auto">
                                            <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                <AutoComplete
                                                    floatingLabelText="Search ticket, customer, title"
                                                    onUpdateInput={this.handleUpdateInput}
                                                    onNewRequest={this.handleNewRequest}
                                                    fullWidth={true}
                                                    placeholder="Search ticket, customer, title"
                                                    filter={AutoComplete.caseInsensitiveFilter}
                                                    dataSource={this.state.search}
                                                    dataSourceConfig={dataSourceConfig}
                                                    errorStyle={{ bottom: 0 }}
                                                    errorText={this.state.errorText}
                                                    maxSearchResults={8}
                                                    className="ticket_search_box"
                                                    onKeyPress={this.enterKeyPress}
                                                    // value={localStorage.getItem("searchvalue")}
                                                    searchText={this.state.searchText}
                                                />
                                            </MuiThemeProvider>
                                            <i class="fa fa-search"></i>
                                        </div>
                                        <div class="searchTicket dept filter hidden-md"><i class="fal fa-filter"></i></div>
                                    </div>
                                </div>
                            </div>
                              </div>
                        <div class="form-section mob_filter filter_dept">
                            <div class="form-horizontal ticketlist_clear" action="/action_page.php">
                                <div class="form-group col-sm-3 col-xs-6" >
                                    <label>Customers Name</label>
                                    <div className={`filter ${this.state.customerclass? 'class': ''}`}>
                                        <Multiselect options={this.state.myAll} 
                                       displayValue="studio_name" 
                                    //    onSelect={ this.handleChange}
                                       selectedValues={this.state.selectedValue} 
                                        onSelect={this.onSelect.bind(this)}
                                        onRemove={this.onRemove.bind(this)}
                                        ref={this.multiselectCustomerName}
                                        onKeyPress={this.onRemove}
                                        />
                                        {/* <i class="fal fa-angle-down"></i> */}
                                    </div>

                                </div>

                                                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Customers Type</label>
                                    <div className={`filter ${this.state.customertypeclass? 'class': ''}`}>
                                       <Multiselect options={[{id:1,type: 'Customers'},{id: 2,type: 'Key Accounts'},
                                       {id: 3,type: 'Leads'}]} 
                                       displayValue="type"  
                                       onSelect={ this.customerSelect} 
                                       onRemove={ this.customerRemove }
                                       onKeyPress={this.customerRemove}
                                       ref={this.customertypeRef}
                                       />
                                    </div>

                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>All Owner</label>
                                    <div className={`filter ${this.state.ownerclass? 'class': ''}`}>
                                    <Multiselect options = {this.state.owners} 
                                       displayValue = "name" onSelect = { this.ownerSelect.bind(this)}
                                       selectedValues = {this.state.owners.filter((item)=>{
                                        return item.id == this.state.userId && this.state.allTicketOwner ? item : '';
                                       })}  
                                       onRemove = {this.ownerRemove.bind(this)}
                                       ref={this.allOwnerRef}
                                       onKeyPress={this.ownerRemove}
                                       />
                                </div>
                            </div>

                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Status</label>
                                    <div class={`filter ${this.state.statusclass ? "class" : ''}`}>
                                     
                                        <Multiselect 
                                        options={[{id: 1,status: 'Open'},{id: 2,status: 'Not Replied'},
                                        {id: 3,status: 'Re-opened'},{id: 7,status: 'Resolved'
            },{id: 4,status: 'Closed'},{id: 5,status: 'SLA Missed'},{id: 8,status: 'Nearing SLA' } ]} 
                                       displayValue="status" onSelect = { this.ticketSelect}
                                       selectedValues={ this.state.allTicketOwner ? [{status: 'Open'},{status: 'Re-opened'}] : ''}
                                       onRemove = {this.ticketRemove}
                                       ref={this.statusRef}
                                       onKeyPress={this.ticketRemove}
                                       value="two"
                                       />
                                    </div>
                                </div>
                             <div className="form-group col-sm-3 col-xs-6" style={{clear:"both"}}>
                                    <label>Ticket Type</label>
                                    <div class={ `filter ${this.state.typeclass? 'class': ''} `}>
                                        <Multiselect options = {[
                {id:'New Feature', type: 'New Feature'}, {id:'Bug', type: 'Bug'},{ id:'How To', type: 'How To'}, { id:'SetupMigration', type: 'Setup/Migration'}
            ]} 
                                       displayValue="type" onSelect = { this.ticketselectoption}
                                       onRemove = {this.ticketremoveoption}
                                       ref={this.ticketTypeRef}
                                       onKeyPress={this.ticketremoveoption}
                                       />
                                    </div>
                                </div> 
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Priority</label>
                                    <div class={ ` filter ${this.state.priorityclass? 'class': '' }` }>
                                        <Multiselect options = {[{type:'critical'},{type:'high'},{type:'medium'},{type: 'low'}]} 
                                       displayValue="type" onSelect = { this.ticketPrioritySelect}
                                       ref={this.priorityRef}
                                       onRemove= {this.ticketPriorityRemove}
                                       onKeyPress={this.ticketPriorityRemove}
                                       />
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Levels</label>
                                    <div class={ ` filter ${this.state.levelclass? 'class': '' }` }>
                                     <Multiselect options = {[{type: 'L1'},{type: 'L2'}, {type: 'L3'}, {type: 'L4'}, {type: 'L5'},{type: 'L6'},{type: 'L7'}]} 
                                       displayValue = "type" onSelect = { this.ticketLevelSelect}
                                       ref={this.levelsRef}
                                       onRemove= {this.ticketLevelRemove}
                                       onKeyPress={this.ticketLevelRemove}
                                       />
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Saved Filters</label>
                                    <div class="filter">
                                        <select class="form-control" id="level1" name="level" onChange={this.savedFilterChange}>
                                            <option value='all' selected="selected">All </option>
                                            {
                                                this.state.saved_filters.map((data, key) =>
                                                    <option value={data.id}>{data.name}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fal fa-angle-down"></i>
                                    </div>

                                    {/* <button  className="btn btn-blue" onClick={()=> this.savefilter()}>Save Current view as Filter</button> */}
                                </div>
                                <div class="btn-muvi pull-right">
                                        <button className="btn btn-blue" onClick={() => this.back()}>Reset</button>
                                        <a href="#" class="btn btn-sky tooltips" data-toggle="modal" data-target="#myModal">Save<span class="tooltiptext">Save Current view as Filter</span></a>
                                        <Link to="/ManageFilter" class="btn btn-sky tooltips">Manage<span class="tooltiptext">Manage Filter</span></Link>
                                    </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        {this.getTicketRows()}
                    </div>
                </div>
            </div>
        );
    }
}
export default TicketList;


// WEBPACK FOOTER //
// ./src/components/support/TicketList.js